import { createVanIconComponent } from "./van"

const Description = createVanIconComponent("description")
export default Description
